import styled from 'styled-components';

export const ModalText = styled.span`
  color: ${({ theme }) => theme.colors.grayDark4};
  font-size: 1rem;
`;

export const ProductTableContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Container = styled.section<{
  bgWhite?: boolean;
  spacing?: 'withSpace' | 'withoutSpace';
}>`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  ${({ spacing }) => spacing === 'withSpace' && `gap: 1rem`};
  ${({ theme, bgWhite }) =>
    bgWhite && `background-color: ${theme.colors.white}`};
`;

export const RowActionContainer = styled.div<{
  withoutPadding?: boolean;
  priceContainer?: boolean;
  optionsGap?: boolean;
  actionHeader?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  padding: ${({ withoutPadding }) =>
    withoutPadding ? '0' : '1.5rem 0 1rem 0'};

  ${({ actionHeader }) => actionHeader && `gap: 1.5rem;`};
  ${({ priceContainer }) => priceContainer && `align-items: center;`};
  ${({ optionsGap }) => optionsGap && `gap: 16px;`};
`;

export const ProductHeaderTitle = styled.div`
  color: #495961;
  .hefesto-title--primary h4 {
    color: #495961;
    margin: 0;
  }
  .hefesto-tag {
    padding: 0;
  }
`;
export const BoxActionContainer = styled.div<{
  chipStrategy?: boolean;
  productHeader?: boolean;
  actionHeader?: boolean;
  hiddenFiscalBenefit?: boolean;
}>`
  display: flex;
  gap: ${({ productHeader }) => (productHeader ? '1rem' : '1.5rem')};
  align-items: center;
  flex-grow: ${({ hiddenFiscalBenefit }) =>
    hiddenFiscalBenefit ? 1 : 'initial'};

  .hefesto-checkbox .hefesto-checkbox__label {
    text-wrap: nowrap;
  }

  .hefesto-datefield__wrapper
    .hefesto-datefield__right-icon-wrapper
    span.hefesto-icon.Calendar.hefesto-icon--full {
    height: 24px;
  }

  .react-calendar__navigation {
    .hefesto-icon.ChevronRight.hefesto-icon--primary.hefesto-icon--full,
    .hefesto-icon.ChevronLeft.hefesto-icon--primary.hefesto-icon--full {
      height: 20px;
    }
  }

  .hefesto-input-wrapper__label-wrapper__label {
    padding: 0 1rem;
  }

  .hefesto-datefield-calendar .hefesto-icon--full {
    width: auto;
  }

  .hefesto-datefield-calendar__info {
    padding: 8px;
    display: flex;
    align-items: center;

    .hefesto-icon.hefesto-icon--full {
      width: 24px;
      height: 24px;
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }

  .hefesto-button {
    min-height: 48px;
    min-width: 48px;
  }

  ${({ chipStrategy }) =>
    chipStrategy &&
    `.hefesto-chip .mdc-chip--selected {
    pointer-events: none;
    }

    span {
      text-wrap: nowrap;
    }

    .mdc-chip-set {
      flex-wrap: nowrap;
    }
    
    .hefesto-chip .chip {
      width: 46px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
    }`};

  ${({ actionHeader }) =>
    actionHeader &&
    ` @media (max-width: 1500px) {
    flex-direction: column;
    align-items: start;
    gap: 8px;
    justify-content: end;
  }`};
`;

export const Text = styled.span<{ bold?: boolean }>`
  font-weight: ${({ bold }) => (bold ? '600' : '400')};
`;

export const ChipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: end;

  @media (max-width: 1500px) {
    margin-left: 32px;
  }
`;

export const ChipTitle = styled.div<{ gray?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 1px 8px;
  color: ${({ gray, theme }) => (gray ? theme.colors.grayDark4 : '#3b5e2e')};
  background-color: ${({ gray, theme }) =>
    gray ? theme.colors.lightGray2 : '#d1dfc4'};
  border-radius: 5rem;
  font-size: 14px;
`;

export const ChipText = styled.span`
  color: ${({ theme }) => theme.colors.grayDark4};
  font-size: 14px;
`;
